/* eslint-disable i18next/no-literal-string */

'use client';
import { Suspense, useEffect } from 'react';

export default function ErrorPage({
  error,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  unstable_retry,
}: {
  error: Error & { digest?: string };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  unstable_retry: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  return (
    <Suspense>
      <p>Sorry, we encountered an error.</p>
      <button type="button" onClick={() => unstable_retry()}>
        Try again
      </button>
    </Suspense>
  );
}
